import type { Artist, ProgramData } from '../lib/types.ts';

/**
 * The announced artists of a program.json, or an empty list when the `artists` block is absent.
 *
 * The block is published unconditionally today, but older publishes omitted it when the year had
 * no visible artists, and every consumer used to read `program.artists.artists` unconditionally —
 * so the whole data load failed and every data-driven section showed "kunne ikke indlæses". Go
 * through this helper so a missing block simply renders as "no artists yet".
 */
export function getProgramArtists(program: Pick<ProgramData, 'artists'> | null | undefined): readonly Artist[] {
  return program?.artists?.artists ?? [];
}
